import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ModalContainer, Button, CloseIcon } from '@surfline/quiver-react';

import config from '../../config';
import devicePropType from '../../propTypes/device';
import FavoriteIcon from '../Icons/FavoriteRegistrationIcon';
import EmailIcon from '../Icons/EmailRegistrationIcon';
import PersonalizeIcon from '../Icons/PersonalizeRegistrationIcon';

class RegistrationModal extends Component {
  registerMe = registrationURL => {
    window.location.assign(registrationURL);
  };

  registrationModalContent = registrationURL => (
    <div className="sl-registration-modal__container">
      <div className="sl-registration-modal__container__header">
        <h2 className="sl-registration-modal__container__header__desktop">
          Create an account to maximize your Surfline experience.
        </h2>
        <h2 className="sl-registration-modal__container__header__mobile">
          Maximize your Surfline experience.
        </h2>
      </div>
      <div className="sl-registration-modal__container__items">
        <div className="sl-registration-modal__container__item">
          <FavoriteIcon />
          <div className="sl-registration-modal__container__item__text">
            <h3>Favorite your Spots</h3>
            <p>Quickly access cams and forecasts for the breaks you care most about.</p>
          </div>
        </div>
        <div className="sl-registration-modal__container__item">
          <PersonalizeIcon />
          <div className="sl-registration-modal__container__item__text">
            <h3>Personalized Homepage</h3>
            <p>Receive news and forecasts tailored to your local area.</p>
          </div>
        </div>
        <div className="sl-registration-modal__container__item">
          <EmailIcon />
          <div className="sl-registration-modal__container__item__text">
            <h3>Email Newsletter</h3>
            <p>The best of Surfline delivered straight to your inbox.</p>
          </div>
        </div>
      </div>
      <div className="sl-registration-modal__container__notes">
        <p>*No credit card required.</p>
      </div>
      <div className="sl-registration-modal__container__options">
        <Button onClick={() => this.registerMe(registrationURL)} parentWidth>
          Create Account
        </Button>
      </div>
    </div>
  );

  render() {
    const { isOpen, onClose, registrationURL, device } = this.props;

    const isMobile = device.width < config.tabletWidth;

    return (
      <div className="sl-registration-modal">
        {!isMobile && (
          <ModalContainer isOpen={isOpen} onClose={onClose} contentLabel="Register">
            {this.registrationModalContent(registrationURL)}
          </ModalContainer>
        )}

        {isMobile && (
          <div>
            {/* eslint-disable-next-line */}
            <div className="sl-registration-modal__container__close" onClick={() => onClose()}>
              <CloseIcon />
            </div>
            {this.registrationModalContent(registrationURL)}
          </div>
        )}
      </div>
    );
  }
}

RegistrationModal.propTypes = {
  registrationURL: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  device: devicePropType.isRequired,
};

RegistrationModal.defaultProps = {
  onClose: null,
};

export default RegistrationModal;
